import { useState, useEffect, useMemo } from 'react';

/**
 * Custom hook for debouncing search queries to improve performance
 * Prevents excessive API calls on rapid typing
 */
export const useDebouncedSearch = (searchQuery: string, delay: number = 300) => {
  const [debouncedValue, setDebouncedValue] = useState(searchQuery);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchQuery);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery, delay]);

  // Memoize to prevent unnecessary re-renders
  return useMemo(() => debouncedValue, [debouncedValue]);
};